import styles from "./declaracionArtefactos.module.css";
import TitlePage from "../../components/titlePage/titlePage";
import ApiFetch from "../../utils/fetch";
import SwalAlert from "../../utils/swalAlert";
import { useContext, useEffect, useState } from "react";
import Loading from "../../components/loading/loading";
import { Alert, Button, IconButton } from "@mui/material";
import { AppContext } from "../../context/context";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import Swal from "sweetalert2";
import AddArtefacto from "./AddArtefacto/AddArtefacto";
import ModalCenter from "../../components/modal/modalCenter";
import CorreosElectronicos from "../correosElectronicos/correosElectronicos";
import UpdateProfile from "../../components/updateProfile/updateProfile";
import ReturnBackButton from "../../components/returnBackButton/ReturnBackButton";

const fetch = new ApiFetch();
const alert = new SwalAlert();

const DeclaracionArtefactos = () => {
  const { sessionExpired } = useContext(AppContext);
  const [myList, setMyList] = useState([]);
  const [loading, setLoading] = useState("");

  //Obtengo los artefactos del cliente
  const getMyList = async () => {
    try {
      setLoading(<Loading />);
      const data = await fetch.GET("/artefactos/lista-cliente");
      setLoading("");
      const status = data?.status;
      const message = data?.message;
      switch (status) {
        case 200:
          setMyList(data?.body);
          break;
        case 401:
          sessionExpired(message);
          break;
        default:
          alert.error(message);
          break;
      }
    } catch (error) {
      setLoading("");
      alert.error(
        "No fue posible obtener sus electrodomésticos. Pruebe reiniciar la página.",
      );
    }
  };

  //Obtengo los artefactos del cliente al renderizar la pagina.
  useEffect(() => {
    getMyList();
  }, []);

  const confirmDeleteArtefacto = (idArtefacto) => {
    Swal.fire({
      text: "¿Desea eliminar el artefacto?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "grey",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await deleteArtefacto(idArtefacto);
      }
    });
  };

  const deleteArtefacto = async (idArtefacto) => {
    try {
      setLoading(<Loading />);
      const data = await fetch.DELETE(`/artefactos/eliminar/${idArtefacto}`);
      setLoading("");
      const status = data?.status;
      const message = data?.message;
      switch (status) {
        case 200:
          alert.success(message);
          await getMyList();
          break;
        case 401:
          sessionExpired(message);
          break;
        default:
          alert.error(message);
          break;
      }
    } catch (error) {
      setLoading("");
      alert.error("No fue posible eliminar el artefacto.");
    }
  };

  return (
    <div className={styles.container}>
      <ReturnBackButton />
      <TitlePage idTramite={7} />
      <Alert severity="warning">
        Los datos cargados son responsabilidad del usuario, por lo tanto debe
        verificar que sean correctos antes de declarar un artefacto. Los
        resarcimientos de los daños serán los contemplados en la{" "}
        <a target="_blank" href="https://www.coop5.com.ar/coop/energia.php">
          Sección reglamento | Res. 11/ Ersep – Art. 3.3.1
        </a>
      </Alert>
      <Alert severity="info" variant="standard">
        COMPLETE LOS SIGUIENTES DATOS PARA AÑADIR UN NUEVO ARTEFACTO
      </Alert>
      <AddArtefacto getMyList={() => getMyList()} />
      <Alert severity="info" variant="standard">
        SUS ARTEFACTOS DECLARADOS
      </Alert>
      <div className={styles.tableContainer}>
        {myList?.length > 0 ? (
          <table className={styles.tableServices}>
            <thead>
              <tr>
                <th>Artefacto</th>
                <th>Marca</th>
                <th>Modelo</th>
                <th>Nro. de serie</th>
                <th>Fecha de alta</th>
                <th></th>
              </tr>
            </thead>
            {myList?.map((artefacto, i) => {
              return (
                <tbody key={i} style={{ fontSize: 12, wordWrap: "break-word" }}>
                  <tr>
                    <td>{artefacto?.Dsartefacto}</td>
                    <td>{artefacto?.Marca}</td>
                    <td>{artefacto?.Modelo}</td>
                    <td>{artefacto?.Nroserie}</td>
                    <td>{artefacto?.Creacion}</td>
                    <td>
                      <IconButton
                        onClick={() =>
                          confirmDeleteArtefacto(artefacto.Idartefacto)
                        }
                        color="error"
                      >
                        <DeleteForeverIcon />
                      </IconButton>
                    </td>
                  </tr>
                </tbody>
              );
            })}
          </table>
        ) : (
          <p>Usted no tiene artefactos declarados.</p>
        )}
      </div>
      {/* <UpdateProfile /> */}
      {loading}
    </div>
  );
};

export default DeclaracionArtefactos;
